// extracted by mini-css-extract-plugin
export default {"cls1":"PingAnswerStyles-cls1_r_G","cls2":"PingAnswerStyles-cls2__M3 PingAnswerStyles-cls1_r_G"};